<template>
  <div class="area-warp">
    <div class="city-name" @click="selectCity">
      <i class="crm-location"></i>
      <span>{{ getCitylabel }}</span>
      <i class="icon-outlinedpickup"></i>
    </div>
    <tree-select
      :options="options"
      :value="areaChecked"
      @input="(v) => $emit('areaChange', v)"
    />
  </div>
</template>
<script>
import treeSelect from '@/components-new/treeSelect/index.vue'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'areaTree',
  components: { treeSelect },
  props: {
    options: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      defaultValue: ['allChild']
    }
  },
  watch: {
    areaChecked(v) {
      console.log(v, '更改的值')
    }
  },
  computed: {
    ...mapState('bizoppV2', [
      'areaChecked',
      'areaCityChecked',
      'areaCityAreaTree'
    ]),

    getCitylabel() {
      return this.areaCityAreaTree.length && this.areaCityChecked.value
        ? this.areaCityAreaTree.find(
            (item) => item.id === this.areaCityChecked.value
          ).label
        : ''
    }
  },
  updated() {
    console.log(this.areaCityChecked, 'vvvvvvvvvvv')
  },
  methods: {
    ...mapMutations('bizoppV2', ['updateAreaChecked']),

    areaChange(val) {
      // this.updateAreaChecked(val)
    },
    selectCity() {
      this.$emit('cityPopupShow')
    }
  }
}
</script>
<style lang="scss" scoped>
.area-warp {
  .city-name {
    font-family: Aspira-Demi;
    font-size: 36px;
    color: #000000;
    text-align: center;
    line-height: 44px;
    font-weight: normal;
    border-radius: 24px 24px 0 0;
    padding: 30px 0;
    .crm-location {
      margin-right: 8px;
      color: #ff7a45;
      vertical-align: middle;
    }
    .icon-outlinedpickup {
      font-size: 32px;
      margin-left: 4px;
      vertical-align: middle;
    }
  }
}
</style>
